

import React, {    } from 'react';
import {  Container,Row  } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import styled from "styled-components";
import DeviceUtils from "../../../helper/DeviceUtils";

import ab from "../../../images/homepage/ab.png"; 
 

const Centeryellow =  styled.div` 
    min-width: 980px;
    width: calc(100% - 190px - 190px);
    color:white;
    padding-top: ${props => props.paddingTop}px;
    background-color: #000000;
    height: ${props => props.height}px;
    position: relative; 
    padding: 0px;
    margin-left: auto;
    margin-right: auto;
    `
    
 
const H4div =  styled.div`  
    position: relative;
    padding: 140px 0px ${props => props.bottom}px calc((100% - 980px) * 0);
    left: ${props => props.Left}px;
    grid-area: 1 / 1 / 2 / 2;
    justify-self: start;
    align-self: start;
 
    color: white;
    font-size: ${props => props.fontSize}px ;
        line-height:1em;  `;


const PageTitle = ({title}) => {


    return ((DeviceUtils.isMobile()===true)?<div>

        <H4div Left={20} bottom={10}  style={{colr:'white',fontFamily: 'oswald-medium,oswald,sans-serif'}} 
        fontSize={(DeviceUtils.isMobile()===true)?40:90} >
                                    {(DeviceUtils.isMobile()===true)?title:title}
        </H4div>
    </div>:<Centeryellow paddingTop={(DeviceUtils.isMobile()===true)?25:80}  height={(DeviceUtils.isMobile()===true)?100:272}  >
 
        <H4div Left={59} bottom={59}  style={{fontFamily: 'oswald-medium,oswald,sans-serif'}} fontSize={(DeviceUtils.isMobile()===true)?35:90} >
                                    {(DeviceUtils.isMobile()===true)?title:title}
        </H4div>  

    </Centeryellow>);
};

export default PageTitle;



// WEBPACK FOOTER //
// ./src/components/homepage_new/common/PageTitle.js